<template>
    <Modal ref="Modal" :title="$t('labels.add_recommendation_product')">
        <div class="modal-body">
            <FormGroup :label="$t('labels.product')">
                <Autocomplete
                    url="/catalog/product-items"
                    :model-value="productRecommendation?.uuid"
                    @update:model-value="productRecommendation = $event"
                    :selected-value="productRecommendation?.name"
                    :selected-values="productRecommendations"
                />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <Button size="sm" @click="addRecommendationProduct" color="indigo">{{ $t('buttons.add') }}</Button>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Autocomplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Button from "../../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: 'AddRecommendationProductModal',
    components: {
        Modal, Autocomplete, FormGroup, Button
    },
    props: {
        productRecommendations: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            productRecommendation: null
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show()
        },
        addRecommendationProduct() {
            httpClient.patch(`/catalog/product-items/${this.$route.params.productUuid}`, {
                product_recommendations: [...this.productRecommendations, this.productRecommendation.uuid]
            }).then(() => {
                this.$emit('update:productRecommendations', this.productRecommendation.uuid)
                this.productRecommendation = null
                this.$refs.Modal.hide()
            })
        }
    }
}
</script>